module.exports = __webpack_public_path__ + "img/icon08.fafadb79.svg";